import { getDictionary, Language, ui } from "../i18n";

export { ui };
export type { Language };

export function getTranslations(language?: string) {
  return getDictionary(language);
}
